/*
 * @@Author: MuYang
 */
import {assign} from 'lodash-es'
import pretreatment from '../pretreatment'
import {HANDLE_SUFFIX, TARGET_TYPE, LAYOUT_TYPE} from '../../constants/index'
import store, {insetSchemaNode} from '../store'
import { pushTarget, popTarget } from '../global-api/target-stack'
// 递归组件
function recursionCreateLayout (nodes, paylodStore, parentPath) {
  return nodes.map(node => {
    return node.targetType ? _createNode(node, paylodStore, parentPath) : node
  }).filter(node => {
    let _is = !node._isDel
    delete node._isDel
    return _is
  })
}

export function _createNode (node, paylodStore, parentPath) {
  node.__targetType = node.targetType
  node.targetType = TARGET_TYPE[node.targetType] || node.targetType
  pushTarget(node.__targetType)
  // 内部格式化
  let cell = pretreatment(node, paylodStore, parentPath)
  // 外部传入shemaHandle
  const nodeConfig = store.handle[node.targetType + HANDLE_SUFFIX]
  if (nodeConfig?.handle) {
    assign(cell, nodeConfig.handle(cell, paylodStore))
  }

  // 递归
  if (cell.viewContent && cell.viewContent.length > 0) {
    cell.viewContent = recursionCreateLayout(cell.viewContent, paylodStore, cell.__path)
  }
  popTarget()
  return cell
}

export function _createOtherNode (layout, payloadStore) {
  if (layout?.data?.expansion) {
    const map = {
      [LAYOUT_TYPE.TARGET_TYPE_SUMMARY]: 'summary',
      [LAYOUT_TYPE.TARGET_TYPE_NORMAL_GROUP]: 'group'
    }
    const expansion = layout?.data?.expansion.map(node => {
      const slots = payloadStore?.config?.expansion || {}
      const soltkey = map[node.targetType] + 'slots'
      node[soltkey] = slots[map[node.targetType]]?.slots || {}
      return _createNode(node, payloadStore, '')
    })
    insetSchemaNode(payloadStore._id, payloadStore.objectApiName, 'expansion', expansion)
  }
}